import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidSentenceReadingGuided } from '../../../../mechanics/rid-sentence-reading-guided/rid-sentence-reading-guided';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-sentence-reading-guided-page',
  imports: [RidSentenceReadingGuided],
  templateUrl: './sentence-reading-guided-page.html',
})
export class SentenceReadingGuidedPage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly pace = computed(() => parseInt(this.queryParams()['pace'] ?? '200'));
  protected readonly mode = computed(() => this.queryParams()['mode'] ?? 'KLANK');
}
